import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, PaletteIcon, DownloadCloudIcon, LightbulbIcon } from 'lucide-react';
const SERVICES = [{
  icon: BookOpenIcon,
  title: 'Aprender',
  description: 'eBooks y guías claras para incorporar un tema nuevo sin vueltas ni relleno.'
}, {
  icon: PaletteIcon,
  title: 'Crear',
  description: 'Plantillas y recursos editables para producir tu contenido y materiales.'
}, {
  icon: LightbulbIcon,
  title: 'Emprender',
  description: 'Herramientas prácticas para poner en marcha una idea y ordenar tu proyecto.'
}, {
  icon: DownloadCloudIcon,
  title: 'Descargar',
  description: 'Acceso inmediato en formatos compatibles, listos para usar desde el primer día.'
}];
export function WhatWeDo() {
  return <section id="servicios" className="relative w-full border-t border-ink/[0.07] bg-paper-alt py-28 sm:py-32 lg:py-40" data-id="element-228" data-mp="eoyvepbgkk0v">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-229" data-mp="3mdxauhy4hg04">
        <div className="max-w-2xl" data-id="element-230" data-mp="3mc2ocz77dftx">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-231" data-mp="3hf2pp9confcu">
            Qué vas a encontrar
          </p>
          <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[2.6rem]" data-id="element-232" data-mp="5e75vcj0tkd">
            Recursos digitales de distintas temáticas,{' '}
            <span className="text-ink-muted" data-id="element-233" data-mp="33mml4444v99t">con un mismo estándar.</span>
          </h2>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-4" data-id="element-234" data-mp="2yp4am9agwlzp">
          {SERVICES.map((service, i) => <motion.li key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="group relative overflow-hidden rounded-3xl border border-ink/[0.07] bg-white p-8 shadow-soft transition-shadow duration-300 hover:shadow-card sm:p-9" data-id="element-235" data-mp="3dejynhim6dbp" data-mpi={i}>
              <span aria-hidden="true" className="absolute -right-10 -top-10 h-28 w-28 rounded-full border border-electric/10" data-id="element-236" data-mp="3edsmeuwwzyk5" />
              <span className="relative grid h-11 w-11 place-items-center rounded-2xl border border-ink/[0.07] bg-paper-alt" data-id="element-237" data-mp="2mn4l9iv8qt6h">
                <service.icon aria-hidden="true" className="h-5 w-5 text-electric" strokeWidth={1.6} data-id="element-238" data-mp="2qny8ea0v03yb" />
              </span>
              <h3 className="relative mt-7 text-[17px] font-semibold tracking-tight text-ink" data-id="element-239" data-mp="30nfdap8aedt8">
                {service.title}
              </h3>
              <p className="relative mt-4 text-[14px] font-light leading-relaxed text-ink-muted" data-id="element-240" data-mp="axc1pqbfn4ht">
                {service.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}